<template>
  <div class="book-cover-box" @click="goBookDetail">
    <van-image fit="fill" lazy-load class="book-cover-img" width="100%" height="100%" :src="bookCoverUrl" />
    <div v-if="showName" class="book-name">
      {{ book.name }}
    </div>
    <span v-if="showLabel" class="label-container">
      <NvLabel :type="labelType" />
    </span>
    <span class="progress-bar-container">
      <NvProgress :progress="progress" />
    </span>
  </div>
</template>

<script>
import NvLabel from "@/components/widget/NvLabel";
import NvProgress from "@/components/widget/NvProgress";
import { saveBooksToLib } from "@/service/api";

export default {
  components: {
    NvLabel,
    NvProgress
  },
  props: {
    book: {
      type: Object,
      default: () => {}
    },
    showName: {
      type: Boolean,
      default: true
    },
    // only two level, so use props instead of provide
    selectable: Boolean,
    showProgress: Boolean
  },
  data() {
    return {
      labelType: "R"
    };
  },
  computed: {
    showLabel() {
      if (this.$route.name === "lib") {
        return !this.book.read_progress;
      }
      return false;
    },
    bookCoverUrl() {
      if (this.book.cover) {
        const baseUrl = process.env.VUE_APP_IMAGE_URL || "";
        return `${baseUrl}/images/` + this.book.cover;
      }
      return "";
    },
    progress() {
      const progress = this.book.read_progress;
      if (!progress) {
        return 0;
      } else {
        const index = progress.chapter_index;
        const total = this.book.chapter_count;
        return ((index + 1) / total) * 100;
      }
    }
  },
  methods: {
    goBookDetail() {
      if (!this.selectable) {
        window.$event("Main_Book_Click", { bookName: this.book.name });
        const extra = {};
        if (this.showLabel) {
          extra.from = "BookShelf Recommend";
          saveBooksToLib(this.book.id);
        } else {
          extra.from = this.$route.meta.pageName;
        }
        this.$router.push({
          name: "content",
          query: { id: this.book.id, name: this.book.name, ...extra }
        });
      } else {
        this.$emit("click", this.book);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.book-cover-box {
  display: inline-block;
  height: 9rem;
  width: 100%;
  position: relative;
  border-radius: 6px;
  &::v-deep {
    .van-image__img {
      border-radius: 6px;
      box-shadow: 0px 1px 1px $color-shadow;
    }
  }
  .book-name {
    margin-top: 5px;
    font-weight: 500;
    font-size: $fs-s;
    text-align: left;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .label-container {
    position: absolute;
    left: 0;
    top: 0;
  }
  .progress-bar-container {
    position: absolute;
    bottom: 10px;
    left: 10px;
    right: 10px;
  }
}
</style>
